const $ = require('cash-dom');
const Page = require('./page');
const Ajax = require('./ajax');
const Template = require('./template');
const Validator = require('./validator');
const JsLinks = require('../common/js-links');

const CouponsPage = {
  page: 1,
  initShowMore: function () {
    const self = this;

    $(document).on('click', '.show-more-coupons', function (e) {
      e.preventDefault();

      Page.startLoad('coupons-list', '.coupons-list-holder');

      $(this).remove();

      self.page++;

      var data = {'_page': self.page};

      Ajax.get(location.href, data, function (html) {
        Page.finishLoad('coupons-list');

        $('.coupons-page').find('.loadable-content').append($(html).find('.coupons-page').find('.loadable-content').html());
      }, 'text');
    });
  },
  initVote: function () {
    $(document).on('click', '.coupon-vote', function (e) {
      e.preventDefault();

      var voter = $(this),
        coupon_id = voter.data('coupon-id'),
        tag = 'coupon-vote-' + coupon_id,
        couponHolder = $('.coupon-holder[data-coupon-id="' + coupon_id + '"]'),
        couponPopup = voter.closest('.coupon-popup-content');

      if (Page.tagIsFree(tag)) {
        Page.startLoad(tag, 'popup');

        Ajax.post(
          ajaxurl,
          {
            action: 'coupon_vote',
            coupon_id: coupon_id,
            vote: !voter.is('.voted') ? voter.data('vote') : 'cancel'
          },
          function (response) {
            if (response.success === true) {
              couponHolder.find('.vote-successful').text(response.successful);

              couponPopup.find('.vote-count').text(response.votes);
              couponPopup.find('.coupon-vote.voted').removeClass('voted');
              couponPopup.find('.coupon-vote[data-vote="' + response.vote + '"]').addClass('voted');
            }
          },
          'json'
        ).always(function () {
          Page.finishLoad(tag);
        });
      }
    });
  },
  initEmailPopup: function () {
    $(document).on('click', '.coupon-email', function (e) {
      e.preventDefault();

      var id = $(this).attr('data-coupon-id');

      Page.closePopups();

      Template.popup($('.coupon-email-popup'), {'id': id}, {className: 'coupon-popup template-popup'});
    });

    $(document).on('click', '.send-coupon-email', function (e) {
      e.preventDefault();

      Page.startLoad('coupon-email', 'popup');

      var popup = $(this).closest('.coupon-email-popup-content'),
        form = $(this).closest('form');

      Ajax.post(ajaxurl, {
        'action': 'coupon_email',
        'email': popup.find('[name="email"]').val(),
        'coupon_id': popup.find('[name="coupon_id"]').val(),
      }, function (res) {
        if (res.success) {
          Page.closePopups();
        } else if (typeof res.errors !== 'undefined' && res.errors.length > 0) {
          Validator.validate(form, res.errors, false);
        }
      }, 'json').always(function () {
        Page.finishLoad('coupon-email');
      });
    });
  },
  initCouponPopup: function () {
    let self = this;

    setTimeout(function () {
      //  let coupon_id = window.location.hash !== 'undefined' && window.location.hash.length > 1 ?
      //    window.location.hash.substr(1) :
      //    '';
      let coupon_id = '';
      let couponMatch = window.location.pathname.match(/coupons\/(\d+)\//);
      if (couponMatch && typeof couponMatch[1] !== 'undefined' && couponMatch[1]) {
        coupon_id = couponMatch[1];
      }
      if (coupon_id) {
        self._showCouponPopup(coupon_id);
      }
    }, 1000);
  },
  couponClick: function (el, targetEl) {
    if (typeof el === 'undefined' || $(targetEl).closest('.share_buttons').length) {
      return false;
    }

    let self = this,
      coupon = $(el).closest('.coupon-holder'),
      couponPermalink = coupon.attr('data-coupon-permalink'),
      redirectLink = $(el).attr('data-href'),
      couponId = coupon.attr('data-coupon-id');

    if (coupon.hasClass('coupon-shortcode')) {
      if (coupon.hasClass('with-code')) {
        self._showCouponPopup(couponId);
      } else {
        JsLinks.emulateLink('', $(el));
      }
    } else {
      if (typeof couponPermalink !== 'undefined' && couponPermalink) {
        JsLinks.emulateLink(couponPermalink, $(el));
        setTimeout(function () {
          window.location.assign(redirectLink);
        }, 300);
      } else {
        self._showCouponPopup(couponId);
      }
    }
  },
  couponKeydown: function (el, event) {
    if (event.keyCode === 13) {
      this.couponClick(el, event.target);
    }
  },
  _showCouponPopup: function (couponId) {
    Ajax.post(ajaxurl, {
      action: 'get_coupon_popup',
      coupon_id: couponId
    }, function (res) {
      if (!res.length) {
        return;
      }

      Template.popup(res, [], {className: 'coupon-popup'});
    }, 'text');
  },
  initShortcodeClick: function () {
    let self = this;

    $(document).on('click', '.coupon-discount-shortcode.with-code', function (e) {
      e.preventDefault();

      let couponId = $(this).attr('data-coupon-id');

      if (couponId) {
        self._showCouponPopup(couponId);
      }
    });
  },
  initTimeleft() {
    const now = Date.now();

    $('[data-timeleft]').each(function () {
      let end = $(this).data('timeleft') * 1000,
        daysLeft = Math.round((end - now) / (1000 * 60 * 60 * 24)),
        text = $(this).data('default');
      if (daysLeft > 0) {
        text = daysLeft + ' ' + (daysLeft > 1 ? tr('days') : tr('day'));
      }
      $(this).text(text);
    });
  },
  init: function () {
    var self = this;

    self.initCouponPopup();
    self.initEmailPopup();
    self.initVote();
    self.initShowMore();
    self.initShortcodeClick();
  }
};

window.CouponsPage = CouponsPage;
module.exports = CouponsPage;
